import React from 'react'
import styled from 'styled-components'
import QRCode from 'qrcode.react'
import { ScanOutlined } from '@ant-design/icons'
import { FenToYuan } from '~/utils'

const StyledCard = styled.div`
  border: 1px solid ${props => props.theme['neutral-300']};
  border-radius: 8px;
  padding: 16px;
  width: 264px;
  margin: 0 auto;
`

const StyledAmountLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme['neutral-900']};
  margin-bottom: 8px;
  font-size: 12px;
  span {
    font-size: 16px;
    color: ${props => props.theme.error};
  }
`

const StyledPayLabel = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${props => props.theme['neutral-400']};
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ScanPayCard: React.FC<{
  amount: number
  icon: string
  url: string
}> = ({ amount, icon, url }) => {
  return (
    <StyledCard>
      <StyledAmountLabel>
        支付金额：<span>¥{FenToYuan(amount)}</span>
      </StyledAmountLabel>
      <div className="w-[200px] h-[200px] bg-neutral-200 rounded-lg p-2 mx-auto">
        <div className="p-1 bg-neutral-900 rounded">
          <QRCode
            value={url || ''}
            size={174}
            fgColor="#000"
            imageSettings={{
              src: icon,
              height: 36,
              width: 36,
              excavate: true,
            }}
          ></QRCode>
        </div>
      </div>
      <StyledPayLabel>
        <ScanOutlined style={{ fontSize: 12 }} className="!text-primary mr-2" />
        请扫码支付
      </StyledPayLabel>
    </StyledCard>
  )
}
